import { useEffect, useState } from "react";
import {
  getAllModules,
  getStandaloneExercise,
  getUserPlaylist,
} from "../../api/api";
import { useAuthContext } from "../../context/AuthContext";
import CreateRoutineDialog from "../playlistDialog/CreateRoutineDialog";
import ic_clock from "../../assets/icons/ic_clock.svg";
import { MemoizedPlaylists, Playlists, SkeletonPlaylist } from "./Playlists";
import { BlueTextLinearGradient } from "../../utils/Utils";

function RoutinePage() {
  const [userPlaylists, setUserPlaylists] = useState([]);
  const [modules, setModules] = useState();
  const [exercises, setExercises] = useState();

  async function updateExerciseList() {
    let response = await getStandaloneExercise();
    const list = {};
    Object.keys(response).map((category, categoryIndex) => {
      const exercises = [];
      response[category].forEach((element) => {
        exercises.push({
          exerciseName: element.exerciseName,
          description: element.exercisesBenefits,
          details: [
            {
              icon: ic_clock,
              text: element.exercisesDuration + " secs",
              alwaysShow: true,
            },
            {
              text: element.exercisescoinsMultipli,
              alwaysShow: false,
            },
          ],
          exerciseUri: element.exerciseURI,
          id: element.exerciseId,
          exerciseImage: element.activityImage,
          exerciseVideo: element.exerciseVideo,
          exerciseAudio: element.exerciseAudio,
          exerciseUrl: element.testURL,
          category: category,
        });
      });
      list[category] = exercises;
    });
    setExercises(list);
  }

  async function updateModules() {
    const response = await getAllModules();
    if (response) setModules(response);
  }
  async function updateUserPlaylists() {
    const response = await getUserPlaylist();
    if (response) setUserPlaylists(response);
    else setUserPlaylists([]);
  }
  const [showCreateRoutine, setShowCreateRoutine] = useState(false);

  useEffect(() => {
    if (showCreateRoutine) {
      if (!exercises) {
        updateExerciseList();
      }
    }
  }, [showCreateRoutine]);

  useEffect(() => {
    updateModules();
    updateUserPlaylists();
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="bg-[#0E0E11]">
      <CreateRoutineDialog
        open={showCreateRoutine}
        close={() => {
          updateUserPlaylists();
          setShowCreateRoutine(false);
        }}
        exercises={exercises}
      />
      <div className="px-6 md:px-16 lg:px-24 2xl:px-32 mt-20">
        <div className="flex items-center md:flex-row flex-col md:space-y-0 space-y-6  bg-black-300 rounded-lg w-full md:px-12 px-6 md:py-3 py-6 mb-10 ">
          <p
            className={`font-medium flex flex-1  ${BlueTextLinearGradient} font-poppins text-xl `}
          >
            Create your own routine from a range of focussed exercises
          </p>
          <div
            className="rounded-full cursor-pointer px-5 py-2 bg-primary-neonGreen"
            onClick={() => {
              setShowCreateRoutine(true);
            }}
          >
            Create a Routine
          </div>
        </div>
        {userPlaylists.length > 0 && (
          <Playlists
            playlistName={"My Routines"}
            playlist={userPlaylists}
            userPlaylist
            onPlaylistDelete={() => {
              updateUserPlaylists();
            }}
          />
        )}
        {modules ? (
          modules?.map((module, index) => {
            return (
              <MemoizedPlaylists
                playlistName={module.category}
                playlist={module.playlist}
                key={index}
              />
            );
          })
        ) : (
          <SkeletonPlaylist numberOfPlaylist={5} />
        )}
      </div>
    </div>
  );
}

export default RoutinePage;
